<template>
  <!-- 菜单权限管理 -->
  <div class="paddbox autobox">
    <div>

      <el-card>
        <!-- <div> <el-form inline :model="searchForm" @submit.prevent>
            <el-form-item label="Id:">
              <el-input v-model="searchForm.id" size="mini" clearable placeholder="配置ID"></el-input>
            </el-form-item>
            <el-form-item label="配置名称:">
              <el-input v-model="searchForm.configName" size="mini" clearable placeholder="模糊查询"></el-input>
            </el-form-item>
            <el-form-item label="创建者:">
              <el-input v-model="searchForm.creator" size="mini" clearable placeholder="创建人名称"></el-input>
            </el-form-item>
            <el-form-item label="执行情况:">
              <el-select v-model="searchForm.status" size="mini" clearable placeholder="全部">
                <el-option label="投放正常" :value="1"></el-option>
                <el-option label="已停用" :value="0"></el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item>
              <el-button type="success" size="mini" @click="handleSearch">提交</el-button>
              <el-button size="mini" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div> -->
        <div class="btn-toolbar">
          <!-- 左侧按钮组 -->
          <div class="left-buttons">
            <el-button-group class="my-btn-group">
              <!-- <el-button icon="el-icon-refresh-right" type="info"></el-button> -->
              <el-button plain size="mini" icon="el-icon-edit" class="btn-orange"
                @click="changeQYBviewFun()">新建全域投放</el-button>
              <el-button plain size="mini" icon="el-icon-edit" class="btn-purple"
                @click="changeAddQYBviewFun()">项目批量追加素材</el-button>
              <el-button plain size="mini" icon="el-icon-edit" class="btn-green"
                @click="changePlayletBatchManageviewFun()">
                手动铺剧
              </el-button>
              <el-button plain size="mini" icon="el-icon-collection" class="btn-blue"
                @click="changeDXBviewFun()">投放定向包管理</el-button>
              <el-button plain size="mini" icon="el-icon-document-remove" class="btn-dark-blue"
                @click="changeTitleviewFun()">短剧标题库</el-button>
              <!-- <el-button plain size="mini" icon="el-icon-picture" class="btn-purple"
                @click="changeVideoFun()">短剧封面图管理</el-button> -->
              <el-button plain size="mini" icon="el-icon-picture" class="btn-red"
                @click="changeProductImageviewFun()">产品主图管理</el-button>
              <el-button plain size="mini" icon="el-icon-video-camera-solid" class="btn-dark"
                @click="changeVideoManageviewFun()">全域剧目管理</el-button>
              <el-button plain size="mini" icon="el-icon-user-solid" class="btn-dark-blue"
                @click="changeDouyingAccountviewFun()">全域抖音号管理</el-button>
              <!-- <el-button plain size="mini" icon="el-icon-picture-outline" class="btn-light-blue">短剧海报管理</el-button>
              <el-button plain size="mini" icon="el-icon-suitcase-1" class="btn-sky">商品包管理</el-button> -->
            </el-button-group>
          </div>

          <!-- 右侧搜索 -->
          <div class="search-right">
            <el-input v-model="searchForm.configName" placeholder="搜索配置名称" size="mini" style="width:180px" clearable
              @keyup.enter="handleSearch"></el-input>
            <el-button icon="el-icon-search" size="mini" @click="handleSearch"></el-button>
            <!-- <el-button icon="el-icon-refresh-right" size="mini" @click="globalAdConfigpageWithTaskStatsFun"></el-button> -->
          </div>
        </div>
        <!-- 下方表格 -->
        <div class="table-wrap">
          <el-table :data="tableData" border stripe highlight-current-row v-loading="loading"
            element-loading-text="加载中..." empty-text="暂无全域投放配置" style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266' }" :row-class-name="tableRowClassName">
            <el-table-column prop="configId" label="配置id" width="50" align="center" :index="tableIndex" />
            <el-table-column label="配置名称 " min-width="240">
              <template #default="scope">
                <div class="cell-config-name">
                  <el-tooltip :content="scope.row.configName || '-'" placement="top" :show-after="300">
                    <span class="link-blue config-title" @click="handleDetail(scope.row)">{{ scope.row.configName || '-'
                    }}</span>
                  </el-tooltip>
                  <!-- <span class="id-line">ID：{{ scope.row.configId ?? scope.row.id ?? '-' }}
                    <el-icon class="copy-icon" @click="copyId(scope.row)">
                      <DocumentCopy />
                    </el-icon>
                  </span> -->
                  <span class="sub-line" v-if="scope.row.platformName || scope.row.platformCode">
                    平台：{{ scope.row.platformName || scope.row.platformCode }}
                    <span v-if="scope.row.monetizeMode"> · {{ monetizeModeText(scope.row.monetizeMode) }}</span>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="执行情况" width="110" align="center">
              <template #default="scope">
                <span v-if="Number(scope.row.status) === 1" class="status-pill success"><i class="dot"></i>执行成功</span>
                <span v-else class="status-pill danger"><i class="dot"></i>执行失败</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="创建信息" width="170" align="center">
              <template #default="scope">
                <div class="cell-create-info">
                  <span class="creator">{{ scope.row.userName || scope.row.creator || '-' }}</span>
                  <span class="time">{{ formatTime(scope.row.createTime) }}</span>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column label="任务总数" width="140" align="center" sortable prop="total">
              <template #default="scope">
                <span class="num strong">{{ scope.row.total ?? 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="成功 / 失败" width="130" align="center">
              <template #default="scope">
                <span class="num ok">{{ scope.row.successCount ?? 0 }}</span>
                <span class="sep">/</span>
                <span class="num fail" :class="{ 'has-fail': (scope.row.failCount ?? 0) > 0 }">{{ scope.row.failCount ??
                  0 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="成功率" width="150" align="center">
              <template #default="scope">
                <div class="rate-cell">
                  <el-progress :percentage="successRate(scope.row)" :stroke-width="8"
                    :status="progressStatus(scope.row)" :show-text="false" />
                  <span class="rate-text">{{ successRate(scope.row) }}%</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="任务详情" min-width="240">
              <template #default="scope">
                <div class="task-detail-cell" @click="handleDetail(scope.row)">
                  <span class="t-item ok">成功：{{ scope.row.successCount ?? 0 }}</span>
                  <span class="t-item fail">失败：{{ scope.row.failCount ?? 0 }}</span>
                  <span class="t-item wait">待执行：{{ scope.row.pendingCount ?? scope.row.pending ?? 0 }}</span>
                  <span class="t-item pending">待投放：{{ scope.row.waitingCount ?? scope.row.waiting ?? 0 }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="更新时间" width="170" align="center">
              <!-- <template #default="scope">
                <span class="time">{{ formatTime(scope.row.updateTime) || formatTime(scope.row.createTime) }}</span>
              </template> -->
              <template #default="scope">
                <span class="time">{{ scope.row.createTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="210" align="center" fixed="right">
              <template #default="scope">
                <div class="op-btns">
                  <span class="link-blue link-op" @click="handleDetail(scope.row)">详情</span>
                  <span class="link-op retry-op" :class="isRetryDisabled(scope.row) ? 'link-disabled' : 'link-blue'"
                    @click="handleRetry(scope.row)">
                    {{ retryBtnText(scope.row) }}
                  </span>
                  <!-- <span class="link-blue link-op" @click="handleEdit(scope.row)">编辑</span> -->
                  <!-- <span class="link-blue link-op" @click="handleTop(scope.row)">置顶</span> -->
                  <!-- <span class="link-blue link-op" :class="Number(scope.row.status) === 1 ? 'link-danger' : 'link-ok'"
                    @click="handleToggleStatus(scope.row)">
                    {{ Number(scope.row.status) === 1 ? '停用' : '启用' }}
                  </span> -->
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
            :pagesize="pagesize" :currentPage="currentPage"></pagination>
        </div>
      </el-card>
    </div>


    <div>
      <!-- 任务详情弹窗：只动本页面表格相关逻辑 -->
      <el-dialog v-model="taskDetailView" :title="`任务详情 — ${taskDetailRow.configName || ''}`" width="85%"
        destroy-on-close>
        <div class="task-filter-bar">
          <el-radio-group v-model="taskStatusFilter" size="small" @change="onTaskStatusChange">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button label="1">成功</el-radio-button>
            <el-radio-button label="2">失败</el-radio-button>
            <el-radio-button label="0">待执行</el-radio-button>
            <el-radio-button label="3">待投放</el-radio-button>
          </el-radio-group>
          <span class="task-summary">
            共 <span class="num-total">{{ taskTotal }}</span> 条
            <span class="t-item ok" v-if="taskList.length">成功 <span class="num-ok">{{ taskSuccessCount }}</span></span>
            <span class="t-item fail" v-if="taskList.length">失败 <span class="num-fail">{{ taskFailCount }}</span></span>
          </span>
        </div>
        <el-table :data="taskList" border stripe v-loading="taskLoading" empty-text="暂无任务数据" style="width: 100%"
          max-height="520">
          <el-table-column label="任务ID" prop="id" width="50" align="center">

          </el-table-column>
          <el-table-column type="expand" label="详情" width="60">
            <template #default="scope">
              <div class="task-expand">
                <div class="expand-row"><span class="expand-label">任务ID：</span>{{ scope.row.id ?? '-' }}</div>
                <div class="expand-row"><span class="expand-label">requestId：</span>{{ scope.row.requestId || '-' }}
                </div>
                <div class="expand-row"><span class="expand-label">responseData：</span>
                  <span class="expand-json">{{ scope.row.responseData || '-' }}</span>
                </div>
                <div class="expand-row"><span class="expand-label">商品库ID：</span>{{ scope.row.productLibraryId || '-'
                }}
                  <span class="expand-label" style="margin-left:16px">商品ID：</span>{{ scope.row.productId || '-' }}
                </div>
                <div class="expand-row"><span class="expand-label">短剧ID：</span>{{ scope.row.dramaId || '-' }}
                  <span class="expand-label" style="margin-left:16px">预计发布时间：</span>{{
                    formatTime(scope.row.estimatePublishTime) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" min-width="220" show-overflow-tooltip />
          <el-table-column prop="advertiserId" label="广告账户ID" width="180" align="center" show-overflow-tooltip />
          <el-table-column prop="awemeId" label="抖音号ID" width="130" align="center" show-overflow-tooltip />
          <el-table-column prop="dramaName" label="短剧" min-width="160" show-overflow-tooltip />
          <el-table-column prop="projectId" label="巨量项目ID" width="140" align="center" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.projectId ?? '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="90" align="center">
            <template #default="scope">
              <el-tag size="small" :type="taskTagType(scope.row.status)">{{ taskStatusText(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="responseMessage" label="回执信息" min-width="220" show-overflow-tooltip>
            <template #default="scope">
              <span :class="{ 'fail-text': Number(scope.row.status) === 2 }">{{ scope.row.responseMessage || '-'
              }}</span>
              <span v-if="scope.row.responseCode !== undefined && scope.row.responseCode !== null" class="code-text">（{{
                scope.row.responseCode }}）</span>
            </template>
          </el-table-column>
          <el-table-column prop="retryCount" label="重试" width="60" align="center" />
          <el-table-column prop="updateTime" label="更新时间" width="170" align="center">
            <template #default="scope">
              {{ formatTime(scope.row.updateTime) }}
            </template>
          </el-table-column>
        </el-table>
        <div class="task-pagination">
          <pagination @handleSizeChange="handleTaskSizeChange" @handleCurrentChange="handleTaskCurrentChange"
            :total="taskTotal" :pagesize="taskPageSize" :currentPage="taskCurrentPage"></pagination>
        </div>
        <template #footer>
          <el-button @click="taskDetailView = false">关闭</el-button>
        </template>
      </el-dialog>

      <!-- 重提失败新建弹窗：确认弹窗提示后调用重提接口 -->
      <el-dialog title="重提失败新建" v-model="retryView" width="560px" destroy-on-close>
        <div class="retry-config-line" v-if="retryRow && (retryRow.configName || retryRow.configId)">
          配置：
          <span class="link-blue" @click="handleDetail(retryRow)">{{ retryRow.configName || `ID ${retryRow.configId}`
          }}</span>
        </div>
        <el-alert type="warning" :closable="false" show-icon class="retry-alert">
          <template #title>
            <span class="retry-alert-title">请确认以下情况已处理后再重提，否则仍可能执行失败：</span>
          </template>
          <ul class="retry-tip-list">
            <li>该剧目今日新增素材已达上限</li>
            <li>当前关联组下，该专辑的全域项目创建额度已超出上限</li>
            <li>当前公司主体下，该专辑的全域项目创建额度已超出上限</li>
            <li>账户未设置头像，请上传(需要已经上传头像)</li>
            <li>网络异常</li>
            <li>QPS 上限</li>
            <li>调用超时等</li>
          </ul>
        </el-alert>
        <div class="retry-tip-foot">确定后将对该配置下的失败任务重新发起新建，提交成功后按钮进入 30 秒倒计时，期间不可重复提交。</div>
        <template #footer>
          <el-button @click="retryView = false">取消</el-button>
          <el-button type="primary" :loading="retrySubmitting" @click="confirmRetryFun">确定</el-button>
        </template>
      </el-dialog>

      <!-- 投放定向包管理弹窗控制 -->
      <el-dialog title="投放定向包管理" v-model="DXBview" width="80%">
        <ylyPackage></ylyPackage>
      </el-dialog>

      <!-- 短剧标题库弹窗控制 -->
      <el-dialog title="短剧标题库" v-model="Titleview" width="80%">
        <ylyTitle></ylyTitle>
      </el-dialog>

      <!-- 产品主图管理弹窗控制 -->
      <el-dialog title="产品主图管理" v-model="ProductImageview" width="80%">
        <ylyProductImage></ylyProductImage>
      </el-dialog>

      <!-- 短剧管理弹窗控制 -->
      <el-dialog title="短剧管理" v-model="VideoManageview" width="80%">
        <ylyVideoManage></ylyVideoManage>
      </el-dialog>

      <el-dialog title="上传测试" v-model="Videoiew" width="80%">
        <ylyUploadVideo></ylyUploadVideo>
      </el-dialog>


      <!-- 抖音号管理弹窗控制 -->
      <el-dialog title="抖音号管理" v-model="DouyingAccountview" width="50%">
        <ylyDouyingAccount></ylyDouyingAccount>
      </el-dialog>

      <!-- 账户拉取视频弹窗控制 -->
      <el-dialog v-model="pullAccountVideoView">
        <div>
          <el-form label-width="80px">
            <el-form-item label="账户id：">
              <el-input type="number" v-model="accountId" placeholder="请输入账户id"></el-input>
            </el-form-item>
            <el-form-item label="素材id：">
              <div>
                <el-input placeholder="请输入素材id，每行一个素材id，敲击回车换行" :rows="20" type="textarea" v-model="desc"></el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="downBtn flex">
          <div>
            <el-button @click="pullAccountVideoViewChange()">取消</el-button>
          </div>
          <div>
            <el-button @click="confirmFun()" type="primary">确定</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 新建全域投放配置弹窗控制 -->
      <el-dialog title="新建全域投放配置" v-model="QYBview" width="80%">
        <form>
          <el-form-item label="防出错项目配置：">
            1111
          </el-form-item>
        </form>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import { globalAdConfigpageWithTaskStats, globalAdConfigtasks, globalAdConfigRetryByConfigId } from '@/request/new/ylyBatch'
import { ElMessage, ElMessageBox } from 'element-plus'
import { DocumentCopy } from '@element-plus/icons-vue'
import { reactive, toRefs, computed, onUnmounted } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件
import ylyPackage from '@/components/ylyBatch/ylyPackage.vue' // 导入定向包组件
import ylyTitle from '@/components/ylyBatch/ylyTitle.vue' // 导入标题库组件
import ylyProductImage from '@/components/ylyBatch/ylyProductImage.vue' // 导入产品主图组件
import ylyVideoManage from '@/components/ylyBatch/ylyVideoManage.vue' // 导入短剧管理
import ylyUploadVideo from '@/components/ylyBatch/ylyUploadVideo.vue' // 导入上传
import ylyDouyingAccount from '@/components/ylyBatch/ylyDouyingAccount.vue' // 导入抖音号管理

export default {
  name: 'quanyuroi3',
  components: { pagination, ylyPackage, ylyTitle, ylyProductImage, ylyVideoManage, ylyUploadVideo, ylyDouyingAccount, DocumentCopy },
  setup() {
    const state = reactive({
      searchForm: {
        id: '',
        configName: '',
        creator: '',
        status: '',
      },
      loading: false,
      //新建全域投放配置开关
      QYBview: false,
      //新建全域投放配置开关控制
      changeQYBviewFun: () => {
        // state.QYBview = !state.QYBview
        window.open('ylyProjectManage', '_blank')
      },
      //全域项目追加素材投放配置开关控制
      changeAddQYBviewFun: () => {
        window.open('ylyProjectAddVideo', '_blank')
      },
      //手动铺剧开关控制
      changePlayletBatchManageviewFun: () => {
        window.open('ylyPlayletBatchManage', '_blank')
      },
      //投放定向包管理开关
      DXBview: false,
      //投放定向包管理开关控制
      changeDXBviewFun: () => {
        state.DXBview = !state.DXBview
      },
      //短剧标题库开关
      Titleview: false,
      //短剧标题库开关控制
      changeTitleviewFun: () => {
        state.Titleview = !state.Titleview
      },
      //产品主图开关
      ProductImageview: false,
      //产品主图开关控制
      changeProductImageviewFun: () => {
        state.ProductImageview = !state.ProductImageview
      },
      //短剧管理开关
      VideoManageview: false,
      //短剧管理开关控制
      changeVideoManageviewFun: () => {
        state.VideoManageview = !state.VideoManageview
      },
      //抖音号管理开关
      DouyingAccountview: false,
      //抖音号管理开关控制
      changeDouyingAccountviewFun: () => {
        state.DouyingAccountview = !state.DouyingAccountview
      },

      Videoiew: false,
      changeVideoFun: () => {
        state.Videoiew = !state.Videoiew
      },

      // ===== 表格行操作（仅本页面） =====
      handleDetail: (row) => {
        state.taskDetailRow = row || {}
        state.taskStatusFilter = ''
        state.taskCurrentPage = 1
        state.taskDetailView = true
        fetchTasksFun()
      },
      handleEdit: (row) => {
        const id = row.configId ?? row.id
        if (id !== undefined && id !== null && id !== '') {
          window.open(`ylyProjectManage?id=${id}`, '_blank')
        } else {
          window.open('ylyProjectManage', '_blank')
        }
      },
      // ===== 重提失败新建（含 30 秒倒计时） =====
      retryView: false,
      retryRow: {},
      retrySubmitting: false,
      // 各配置的重提冷却剩余秒数，key 为 configId
      retryCooldown: {},
      getConfigKey: (row) => String((row && (row.configId ?? row.id)) ?? ''),
      isRetryDisabled: (row) => {
        const key = state.getConfigKey(row)
        return !!key && Number(state.retryCooldown[key] || 0) > 0
      },
      retryBtnText: (row) => {
        const key = state.getConfigKey(row)
        const left = Number(state.retryCooldown[key] || 0)
        return left > 0 ? `重提失败新建(${left}s)` : '重提失败新建'
      },
      handleRetry: (row) => {
        if (state.isRetryDisabled(row)) return
        state.retryRow = row || {}
        state.retryView = true
      },
      handleTop: (row) => {
        const idx = state.tableData.findIndex((item) => (item.configId ?? item.id) === (row.configId ?? row.id))
        if (idx > 0) {
          const [topRow] = state.tableData.splice(idx, 1)
          state.tableData.unshift(topRow)
          ElMessage.success(`已将「${row.configName || row.configId || ''}」置顶（仅当前页排序）`)
        } else if (idx === 0) {
          ElMessage.info('该配置已在顶部')
        }
      },
      handleToggleStatus: (row) => {
        const next = Number(row.status) === 1 ? 0 : 1
        const action = next === 1 ? '启用' : '停用'
        ElMessageBox.confirm(`确定要${action}「${row.configName || ''}」吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          row.status = next
          ElMessage.success(`${action}成功（仅前端状态，待接启用/停用接口后持久化）`)
        }).catch(() => { })
      },
      copyId: (row) => {
        const id = String(row.configId ?? row.id ?? '')
        if (!id) return
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(id).then(() => ElMessage.success('ID已复制')).catch(() => ElMessage.info(`ID：${id}`))
        } else {
          ElMessage.info(`ID：${id}`)
        }
      },
      tableRowClassName: ({ row }) => {
        return Number(row.status) === 1 ? '' : 'row-disabled'
      },
      tableIndex: (index) => {
        return (state.currentPage - 1) * state.pagesize + index + 1
      },
      successRate: (row) => {
        const total = Number(row.total ?? 0)
        const success = Number(row.successCount ?? 0)
        if (!total) return 0
        return Math.round((success / total) * 1000) / 10
      },
      progressStatus: (row) => {
        const fail = Number(row.failCount ?? 0)
        if (fail > 0) return 'exception'
        const total = Number(row.total ?? 0)
        const success = Number(row.successCount ?? 0)
        if (total > 0 && success === total) return 'success'
        return ''
      },
      monetizeModeText: (mode) => {
        if (mode === 'IAP') return '用户付费(IAP)'
        if (mode === 'IAA_AND_IAP') return '混合投放(IAA+IAP)'
        return mode || '-'
      },
      formatTime: (t) => {
        if (!t) return '-'
        const s = String(t)
        return s.length > 19 ? s.slice(0, 19).replace('T', ' ') : s.replace('T', ' ')
      },
      taskTagType: (s) => {
        const n = Number(s)
        if (n === 1) return 'success'
        if (n === 2) return 'danger'
        if (n === 0) return 'info'
        if (n === 3) return 'warning'
        return 'info'
      },
      taskStatusText: (s) => {
        const n = Number(s)
        if (n === 0) return '待执行'
        if (n === 1) return '成功'
        if (n === 2) return '失败'
        if (n === 3) return '待投放'
        return s ?? '-'
      },

      // ===== 任务详情弹窗（仅本页面） =====
      taskDetailView: false,
      taskDetailRow: {},
      taskList: [],
      taskLoading: false,
      taskStatusFilter: '',
      taskCurrentPage: 1,
      taskPageSize: 20,
      taskTotal: 0,
      taskTableIndex: (index) => {
        return (state.taskCurrentPage - 1) * state.taskPageSize + index + 1
      },
      onTaskStatusChange: () => {
        state.taskCurrentPage = 1
        fetchTasksFun()
      },
      handleTaskCurrentChange: (e) => {
        state.taskCurrentPage = e
        fetchTasksFun()
      },
      handleTaskSizeChange: (e) => {
        state.taskPageSize = e
        state.taskCurrentPage = 1
        fetchTasksFun()
      },

      // 表格数据
      tableData: [],
      // 条数
      pagesize: 20,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 0,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        globalAdConfigpageWithTaskStatsFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        // state.currentPage = 1
        globalAdConfigpageWithTaskStatsFun()
      },
      // 搜索 / 重置（仅本页面表格查询）
      handleSearch: () => {
        // state.currentPage = 1
        globalAdConfigpageWithTaskStatsFun()
      },
      handleReset: () => {
        state.searchForm = { id: '', configName: '', creator: '', status: '' }
        state.currentPage = 1
        globalAdConfigpageWithTaskStatsFun()
      },
    })

    const taskSuccessCount = computed(() => state.taskList.filter((t) => Number(t.status) === 1).length)
    const taskFailCount = computed(() => state.taskList.filter((t) => Number(t.status) === 2).length)

    const fetchTasksFun = () => {
      const row = state.taskDetailRow || {}
      const configId = row.configId ?? row.id
      if (configId === undefined || configId === null || configId === '') {
        state.taskList = []
        state.taskTotal = 0
        return
      }
      state.taskLoading = true
      const params = {
        configId,
        currentPage: state.taskCurrentPage,
        size: state.taskPageSize,
      }
      if (state.taskStatusFilter !== '' && state.taskStatusFilter !== null && state.taskStatusFilter !== undefined) params.status = state.taskStatusFilter
      globalAdConfigtasks(params).then((res) => {
        const payload = res && res.data !== undefined ? res.data : res
        state.taskCurrentPage = payload.currenPage ?? payload.currentPage ?? state.taskCurrentPage
        state.taskTotal = payload.totalSize ?? payload.total ?? 0
        const list = payload.data ?? payload.list ?? payload.records ?? []
        state.taskList = Array.isArray(list) ? list : []
      }).catch(() => {
        state.taskList = []
        state.taskTotal = 0
        ElMessage.error('任务详情加载失败')
      }).finally(() => {
        state.taskLoading = false
      })
    }

    // 分页查询（带任务详情统计）：配置名称模糊查询
    const globalAdConfigpageWithTaskStatsFun = () => {
      state.loading = true
      const datas = {
        currentPage: state.currentPage,
        size: state.pagesize,
        configName: state.searchForm.configName || null,
      }
      if (state.searchForm.id) datas.configId = state.searchForm.id
      if (state.searchForm.status !== '' && state.searchForm.status !== null && state.searchForm.status !== undefined) datas.status = state.searchForm.status
      globalAdConfigpageWithTaskStats(datas).then((res) => {
        const payload = res && res.data !== undefined ? res.data : res
        state.currentPage = payload.currenPage ?? payload.currentPage ?? state.currentPage
        state.total = payload.totalSize ?? payload.total ?? 0
        let list = payload.data ?? payload.list ?? payload.records ?? []
        // 前端兜底过滤：创建者关键字（后端目前仅支持配置名称模糊查询）
        if (state.searchForm.creator) {
          const kw = String(state.searchForm.creator)
          list = list.filter((item) => String(item.userName || item.creator || '').includes(kw))
        }
        if (state.searchForm.id && !datas.configId) {
          const kw = String(state.searchForm.id)
          list = list.filter((item) => String(item.configId ?? item.id ?? '').includes(kw))
        }
        state.tableData = Array.isArray(list) ? list : []
      }).catch(() => {
        ElMessage.error('配置列表加载失败')
      }).finally(() => {
        state.loading = false
      })
    }

    globalAdConfigpageWithTaskStatsFun()

    // ===== 重提失败新建：提交接口 + 30 秒倒计时 =====
    // 倒计时定时器（普通对象，不参与响应式）
    const retryTimers = {}
    const RETRY_COOLDOWN = 30

    const startRetryCooldown = (configId) => {
      const key = String(configId ?? '')
      if (!key) return
      state.retryCooldown[key] = RETRY_COOLDOWN
      if (retryTimers[key]) clearInterval(retryTimers[key])
      retryTimers[key] = setInterval(() => {
        const left = Number(state.retryCooldown[key] || 0) - 1
        if (left <= 0) {
          clearInterval(retryTimers[key])
          delete retryTimers[key]
          delete state.retryCooldown[key]
        } else {
          state.retryCooldown[key] = left
        }
      }, 1000)
    }

    const confirmRetryFun = () => {
      const row = state.retryRow || {}
      const configId = row.configId ?? row.id
      if (configId === undefined || configId === null || configId === '') {
        ElMessage.warning('缺少配置ID，无法重提')
        return
      }
      if (state.retrySubmitting) return
      state.retrySubmitting = true
      globalAdConfigRetryByConfigId({ configId }).then((res) => {
        const code = res?.code
        if (code !== undefined && code !== null && Number(code) !== 200) {
          ElMessage.error(res?.msg || '重提失败')
          return
        }
        state.retryView = false
        ElMessage.success('已提交重提，稍后可在任务详情中查看结果')
        startRetryCooldown(configId)
        globalAdConfigpageWithTaskStatsFun()
      }).catch(() => {
        ElMessage.error('重提失败，请稍后重试')
      }).finally(() => {
        state.retrySubmitting = false
      })
    }

    onUnmounted(() => {
      Object.keys(retryTimers).forEach((key) => {
        clearInterval(retryTimers[key])
        delete retryTimers[key]
      })
    })

    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      globalAdConfigpageWithTaskStatsFun,
      fetchTasksFun,
      taskSuccessCount,
      taskFailCount,
      confirmRetryFun,
    }
  },
}
</script>

<style lang="scss" scoped>
.table-wrap {
  margin-top: 12px;
}

.cell-config-name {
  display: flex;
  flex-direction: column;
  line-height: 20px;
  gap: 2px;
}

.config-title {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 100%;
}

.link-blue {
  color: #409eff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.link-op {
  margin-right: 10px;
  white-space: nowrap;
}

.retry-op {
  white-space: nowrap;
}

.link-disabled {
  color: #c0c4cc;
  cursor: not-allowed;

  &:hover {
    text-decoration: none;
  }
}

.link-danger {
  color: #f53f3f;
}

.link-ok {
  color: #00b42a;
}

.op-btns {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2px 0;
}

.id-line {
  color: #909399;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.copy-icon {
  cursor: pointer;
  font-size: 12px;

  &:hover {
    color: #409eff;
  }
}

.sub-line {
  color: #909399;
  font-size: 12px;
}

.cell-create-info {
  display: flex;
  flex-direction: column;
  line-height: 20px;

  .creator {
    color: #303133;
  }

  .time,
  &.time {
    color: #909399;
    font-size: 12px;
  }
}

.time {
  color: #606266;
  font-size: 12px;
}

.num {
  font-weight: 600;

  &.strong {
    color: #303133;
  }

  &.ok {
    color: #00b42a;
  }

  &.fail {
    color: #909399;
  }

  &.has-fail {
    color: #f53f3f;
  }
}

.sep {
  color: #dcdfe6;
  margin: 0 4px;
}

.rate-cell {
  display: flex;
  align-items: center;
  gap: 8px;

  :deep(.el-progress) {
    flex: 1;
  }

  .rate-text {
    font-size: 12px;
    color: #606266;
    min-width: 44px;
    text-align: right;
  }
}

.task-detail-cell {
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
  font-size: 13px;
  line-height: 20px;

  &:hover {
    background: #f5f7fa;
    border-radius: 4px;
  }

  .t-item {
    white-space: nowrap;

    &.ok {
      color: #00b42a;
    }

    &.fail {
      color: #f53f3f;
    }

    &.wait {
      color: #e6a23c;
    }

    &.pending {
      color: #909399;
    }
  }
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  white-space: nowrap;

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }

  &.success {
    color: #00b42a;
    background: rgba(0, 180, 42, 0.1);
  }

  &.danger {
    color: #909399;
    background: #f4f4f5;
  }
}

.task-filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;

  .task-summary {
    font-size: 13px;
    color: #606266;
    display: flex;
    align-items: center;
    gap: 10px;

    .num-total {
      color: #409eff;
      font-weight: 600;
    }

    .t-item.ok {
      color: #606266;
    }

    .t-item.fail {
      color: #606266;
    }

    .num-ok {
      color: #00b42a;
      font-weight: 600;
    }

    .num-fail {
      color: #f53f3f;
      font-weight: 600;
    }
  }
}

.task-pagination {
  margin-top: 12px;
  display: flex;
  justify-content: center;
}

.task-expand {
  background: #f8fafc;
  padding: 8px 12px;
  font-size: 12px;
  color: #606266;
  line-height: 22px;
  word-break: break-all;

  .expand-label {
    color: #909399;
  }

  .expand-json {
    color: #606266;
  }
}

.fail-text {
  color: #f53f3f;
}

.code-text {
  color: #909399;
  font-size: 12px;
}

.retry-config-line {
  font-size: 13px;
  color: #606266;
  margin-bottom: 12px;
}

.retry-alert {
  align-items: flex-start;

  .retry-alert-title {
    font-size: 13px;
    font-weight: 600;
  }
}

.retry-tip-list {
  margin: 8px 0 0;
  padding-left: 18px;
  line-height: 22px;
  font-size: 13px;
  color: #606266;
}

.retry-tip-foot {
  margin-top: 12px;
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}

:deep(.row-disabled) {
  background: #fafafa;
  color: #909399;
}

.search-right {
  margin-left: auto;
  display: flex;
  gap: 4px;
}

.btn-toolbar {
  display: flex;
  flex-wrap: nowrap;
  /* 整体强制一行，绝不换行 */
  align-items: center;
  gap: 12px;
  width: 100%;
}

.left-buttons {
  display: flex;
  gap: 2px;
  /* 允许左侧按钮容器内部压缩，空间不够就挤压，不换行 */
  flex-shrink: 1;
  overflow-x: auto;
  /* ✅重点：按钮太多，左侧出现横向滚动条，保证搜索框永远钉在同一行最右边 */
  padding-bottom: 4px;
}

.search-right {
  flex-shrink: 0;
  /* ✅重点：搜索区域禁止被压缩，固定在最右侧，绝不换行 */
  display: flex;
  gap: 4px;
  margin-left: 12px;
}

/* 你的按钮颜色样式保留 */
.btn-orange {
  background-color: #ff9500;
  color: white;
  border: none;
}

.btn-green {
  background-color: #00b42a;
  color: white;
  border: none;
}

.btn-blue {
  background-color: #409eff;
  color: white;
  border: none;
}

.btn-dark-blue {
  background-color: #2b5cb8;
  color: white;
  border: none;
}

.btn-purple {
  background-color: #722ed1;
  color: white;
  border: none;
}

.btn-red {
  background-color: #f53f3f;
  color: white;
  border: none;
}

.btn-dark {
  background-color: #1d2129;
  color: white;
  border: none;
}

.btn-light-blue {
  background-color: #69b1ff;
  color: white;
  border: none;
}

.btn-sky {
  background-color: #40c9ff;
  color: white;
  border: none;
}
</style>
